import { Skeleton, Typography } from "@mui/material";
import dayjs from "dayjs";
import { useHotkeys } from "react-hotkeys-hook";
import PVSignatures from "components/ui/atoms/PVSignatures";
import Layout from "components/ui/molecules/Layout";
import CommitteeMinutePrintListCondensed from "models/committee/CommitteeMinutePrintListCondensed";
import { useGetCommitteeMinute } from "models/committee/apiCommitteeMinute";
import { useParams } from "react-router-dom";

const CommitteeMinutePrint = ({}) => {
  const { committee_minute_id } = useParams();
  const {
    data: committeeMinute,
    isSuccess: committeeMinuteIsSuccess,
    isError: committeeMinuteIsError,
  } = useGetCommitteeMinute(committee_minute_id);

  useHotkeys(
    "meta+p",
    () => {
      window.print();
    },
    { preventDefault: true },
  );

  if (committeeMinuteIsError) {
    return <>Error</>;
  }

  if (!committeeMinuteIsSuccess) {
    return <></>;
  }

  return (
    <>
      <Typography textAlign="center" variant="h6">
        Investment committee
      </Typography>
      <Typography textAlign="center" variant="subtitle2">
        {committeeMinute.deal_flow.name}
      </Typography>
      <Typography textAlign="center" variant="body2">
        {dayjs(committeeMinute.created_at).format("DD-MM-YYYY HH:mm")}
      </Typography>
      <Layout content>
        {committeeMinuteIsSuccess ? (
          <CommitteeMinutePrintListCondensed
            committeeMinuteId={committeeMinute.id}
          />
        ) : (
          <Skeleton variant="rectangular" height={150} />
        )}
      </Layout>
      <PVSignatures signatures={committeeMinute.deal_flow.signatures_detail} />
    </>
  );
};

export default CommitteeMinutePrint;
